import * as ErrorCodes from './errorCodes';

export const defaultErrorResponse = {
  errorCode: ErrorCodes.UNKNOWN,
  message:
    "We apologize for any inconvenience. REITSuite has experienced an unexpected error. Please refresh your browser and try again. You could also try clearing your browser's cache and try again.",
};
